<mat-card appearance="outlined" class="cardSearchBy">
	<h2 style="padding-left:18px;padding-top:5px;">Search By</h2>
	<mat-card-content>
		<form [formGroup]="searchSchoolDistrictsForm" class="formSchoolSearch">
			<!--(ngSubmit)="fnSearch()" -->
			<div class="form-group">
				<div class="row">
					<div class="col-12">
						<mat-form-field class="field-full-width" appearance="fill" tabindex="0">
							<mat-label>School District Name</mat-label>
							<input id="schoolDistrictName" 
								formControlName="schoolDistrictName" 
								type="text" 
								matInput
								#message 
								maxlength="100" 
								minlength="20"
								class="form-control 
								field-full-width"
								placeholder="School District Name (partial allowed)" pattern="[A-Za-z]">
							<mat-hint align="start"><strong>(partial allowed)</strong> </mat-hint>
						</mat-form-field>
					</div>
				</div>
				<div class="row topSpace">
					<div class="col-6">
						<span class="flushLeftAbsolute"><label>School District Code</label>
						</span>
					</div>
					<div class="col-6">
						<label>NCES</label>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<mat-form-field class="field-full-width" tabindex="2" appearance="fill">
							<input id="schoolDistrictCode" 
								#schoolDistrictCode 
								formControlName="schoolDistrictCode" 
								type="tel"
								pattern="[0-9]" 
								(keydown)="onKeyDown($event)"
								(input)="inputValidator($event)"
								class="form-control" 
								matInput 
								placeholder="&nbsp;&nbsp;xxxxx" 
								maxlength="5">
						</mat-form-field>&nbsp;&nbsp;
					</div>
					<div class="col-6">
						<mat-form-field class="field-full-width" tabindex="5" appearance="fill">
							<input id="schoolDistrictNCES" formControlName="schoolDistrictNCES" #cityfromcds type="text"
								matInput class="form-control" 
								(keydown)="onKeyDown($event)"
								#message maxlength="7" placeholder="xxxxxxx"
								pattern="[0-9]">
						</mat-form-field>
					</div>
				</div>
				<p></p>
			</div>
			<!-- class="flushLeft "-->
			<div class="row">
				<!--  [ngClass]="{'disable': isLoadingResults}"  || isLoadingResults-->
				<div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<button (click)="fnSearch()" 
						mat-raised-button 
						color="primary"
						(onSearchErrorEvent)="catchSearchError($event)" 
						matTooltip="Create new school district" style="margin-bottom:5px;margin-top:5px;vertical-align:center;">Search</button>&nbsp;&nbsp;
					<!--[disabled]="!checkValid()"
						 type="submit" -->
					<button mat-raised-button (click)="fnReset()" matTooltip="Reset search parameters" color="accent">Reset</button>&nbsp;&nbsp;
					
					<ng-container *ngIf="bCancelCreate"><button mat-raised-button matTooltip="Cancel create"
							(click)="fnCancelCreate()" class="btnRaise" style="margin-bottom:5px;vertical-align:center;">{{createBtnText}}<mat-icon class="iconDisplay">close
							</mat-icon></button></ng-container>		
				</div>
				<div class="col-12 col-xs-7 col-sm-7 col-md-7 col-lg-8">
					<div class="error-wrapper"  *ngIf="myError">
						<textarea class="errorMsg" id="txtErrorMsg" readonly="true" rows="2"
						style="resize:none;">{{myError}}</textarea>
					</div>
				</div>
			</div>
		</form>
	</mat-card-content>
</mat-card>